<div class="flex items-center justify-between mb-1 gap-2">
    <p class="font-poppins font-medium text-[12px] text-secundary">
        Tipo de archivo: {{ getValidFormatsText() }}.
    </p>
    <p class="font-poppins font-medium text-[12px] text-secundary">
        Tamaño máximo: {{ maxFileSizeMB }} MB.
    </p>
</div>
<div class="box-border flex flex-col justify-center items-center space-y-2 w-full h-[200px] border border-dashed border-primary-g500 rounded-2xl py-8 transition-colors"
    [class.bg-primary-g50]="isDragOver" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)">
    @if(!isLoading) {
    <div class="flex flex-row justify-center items-center w-6 h-6 flex-none order-0 flex-grow-0">
        <div class="relative w-6 h-6">
            <i class="fi fi-rr-upload w-full h-full text-xl leading-none flex items-center justify-center"></i>
        </div>
    </div>

    <div
        class="flex flex-col justify-center items-center p-0 space-y-1 w-full h-auto flex-none order-1 self-stretch flex-grow-0">
        <p
            class="font-poppins font-normal text-sm px-4 leading-5 text-text-primary text-center flex-none order-0 flex-grow-0">
            Arrastra y suelta tu archivo aquí
        </p>
        <p
            class="font-lexend font-normal text-xs leading-[18px] text-text-secondary text-center flex-none order-1 flex-grow-0">
            o
        </p>
    </div>

    <button type="button"
        class="box-border flex flex-row justify-center items-center py-2 px-4 h-9 border-2 border-[#27313F] rounded-2xl flex-none order-2 flex-grow-0"
        (click)="fileInput.click()">
        <span class="font-lexend font-medium text-sm text-[#27313F] flex-none order-1 flex-grow-0">
            Seleccionar archivo
        </span>
        <input #fileInput type="file" class="hidden" [attr.accept]="getAcceptAttribute()"
            (change)="onFileChange($event)" />
    </button>
    } @else {
    <div class="flex flex-row items-center justify-center w-full">
        <img src="svg/loading-icon.svg" alt="Cargando" class="w-8 h-8 animate-spin" />
        <span class="font-poppins font-normal text-[14px] text-text-primary ml-2 leading-5">Cargando...</span>
    </div>
    }
</div>